import * as Yup from "yup";

export const stringNotRequired = Yup.string()
  .max(50, "Too Long!")
  .notRequired();
